import { Component, OnInit, computed, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { TranslatePipe, PrefixSubscriptionPipe, PrependDevUrlForEnvDevelopmentPipe } from '../../../../utils/pipes';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { AvatarComponent } from '../../misc/avatar/avatar.component';
import { DefaultService, NotificationEvent } from '../../../../utils/api';
import { Subscription } from 'rxjs';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { LegacyLinkInnerDirective } from '../../../../utils/directives';
import { CommonModule } from '@angular/common';
import { NotificationIconComponent } from '../../../../modules/admin/components/messages/notification-icon/notification-icon.component';

@Component({
    selector: 'app-navigation',
    imports: [
        RouterModule,
        AvatarComponent,
        NgbPopoverModule,
        TranslatePipe,
        LegacyLinkInnerDirective,
        PrefixSubscriptionPipe,
        CommonModule,
        NotificationIconComponent,
        PrependDevUrlForEnvDevelopmentPipe
    ],
    templateUrl: './navigation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './navigation.component.scss'
})
export class NavigationComponent implements OnInit {
    authService = inject(AuthService);
    translatePipe = inject(TranslatePipe);
    prefixSubscriptionPipe = inject(PrefixSubscriptionPipe);
    router = inject(Router);
    defaultService = inject(DefaultService);

    user = this.authService.user;

    notifications = signal<NotificationEvent[]>([]);
    computedNotifications = computed(() =>
        this.notifications().map((x) => {
            const isExtLink = (link: string): boolean => {
                try {
                    const url = new URL(link.startsWith('www.') ? `https://${link}` : link);
                    return url.hostname !== 'medbook.' && !url.hostname.endsWith('.medbook.');
                } catch {
                    return false;
                }
            };
            return {
                ...x,
                isExtLink: x.link ? isExtLink(x.link) : false
            };
        })
    );
    unreadNotifications = computed(() => this.computedNotifications().filter((x) => !x.read));
    notificationsSubscription: Subscription;
    currentNotificationsOpened = false;
    previousPathname: string;
    url = '';

    switchingToAccountId: number;

    // legacy
    angularNavCodes: string[] = ['portfolio', 'assistants'];

    ngOnInit() {
        this.getNotifications();
        this.router.events.subscribe((next) => {
            if (next instanceof NavigationEnd && window.location.pathname !== this.previousPathname) {
                this.previousPathname = window.location.pathname;
                this.getNotifications();
                this.setUrl();
            }
        });
        this.setUrl();
    }

    setUrl() {
        this.url = window.location.pathname;
    }

    getNotifications() {
        this.previousPathname = window.location.pathname;
        this.notificationsSubscription?.unsubscribe();
        this.notificationsSubscription = this.defaultService
            .notificationGetNotificationsForSubscription({
                importance: [1],
                targetSubscriptionid: this.user()?.subscriptionId
            })
            .subscribe((next) => {
                this.notifications.set(next);
                this.currentNotificationsOpened = false;
            });
    }

    onOpenNotifications() {
        this.currentNotificationsOpened = true;
    }

    onCloseNotifications() {
        if (this.unreadNotifications()?.length) {
            this.defaultService
                .notificationMarkNotificationAsRead({ ids: this.unreadNotifications().map((x) => x.id) })
                .subscribe(() => {
                    this.notifications.update((value) => value.map((notif) => ({ ...notif, read: true })));
                });
        }
    }

    switchAccount($event: Event, id: number) {
        if (id === this.user().subscriptionId) {
            $event.preventDefault();
            return;
        }
        this.switchingToAccountId = id;
    }
}
